import { FactoryProvider } from '@angular/core';

import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

import { BREADCRUMB_TRANSLATIONS, BreadcrumbTranslations } from '@hdms/shared/ui-core';

export const BREADCRUMB_TRANSLATION_PROVIDER: FactoryProvider = {
  provide: BREADCRUMB_TRANSLATIONS,
  deps: [I18NEXT_SERVICE],
  useFactory: (i18NextService: ITranslationService): BreadcrumbTranslations => ({
    ariaLabel: i18NextService.t('breadcrumb.ariaLabel')
  })
};
